import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from 'react-alert';
import { UserContext } from "../../../UserContext";

import CenteredPageContainer from "../layout_components/CenteredPageContainer";
import Button from "../common_components/Button";
import TextButton from "../common_components/TextButton";
import MissionCardLayout from "../layout_components/MissionCardLayout";
import FilterButton from "./FilterButton";
import CenteredLoadingIcon from "../common_components/CenteredLoadingIcon";
import MissionCardButtonAndSubText from "./MissionCardButtonAndSubText";
import ClockIcon from "../../../../../../assets/images/user_app/mission_card/clock_icon.svg"


// API Calls
import MissionAPI from "../../api/api_calls/MissionAPI";


function MissionCard({ mission, format, reward, status, spotsRemaining, missionType, missionLocked, lockedReason }) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { user, setUser, refreshUser } = useContext(UserContext);

    return (
        <div className="mission-card" onClick={() => navigate(`/missions/${mission.id}`)}>
            <div className="mission-card-description-content">
                <div className="mission-card-text-content-container">
                    <h2 className="mission-card-title">
                        {mission.name}
                    </h2>
                    <div className="mission-card-description body-large">
                        {mission.audience_description}
                    </div>
                </div>
                <div className="mission-card-length-description-container">
                    <img src={ClockIcon} alt="Clock Icon" className="mission-card-clock-icon" />
                    <div className="mission-card-length-description body-small">
                        {format}
                    </div>
                </div>
            </div>
            <div className="mission-card-vertical-divider"></div>
            <div className="mission-card-apply-button-content">
                <div className="reward-content-container">
                    <div className="reward-amount">
                        {reward}
                    </div>
                    <div className="reward-description">
                        Reward
                    </div>
                </div>
                <div className="apply-button-content-container">
                    <MissionCardButtonAndSubText mission={mission} status={status} spotsRemaining={spotsRemaining} missionType={missionType} missionLocked={missionLocked} lockedReason={lockedReason} />
                </div>
            </div>
        </div>
    );

}

export default MissionCard;